import React, { useMemo } from 'react';
import { PatientProfileInfoAccordion } from './PatientProfileInfoAccordion';
import { Box, Typography } from '@mui/material';
import { ShowMoreContent } from './ShowMoreContent.component';
import { usePatientFamilyHistory } from '@uplift/queries';

export type FamilyHistoryAccordianProps = {
  patientId: string;
};

export const FamilyHistoryAccordian: React.VFC<FamilyHistoryAccordianProps> = ({ patientId }) => {
  const { data: familyHistory = [] } = usePatientFamilyHistory(patientId);

  const content = useMemo(() => {
    if (!familyHistory.length) {
      return <Typography variant="body2" color="textPrimary">No family history on record</Typography>;
    }

    return (
      <ShowMoreContent
        buttonText={showingMore => showingMore ? 'Show Less' : 'Show More'}
        canShowMore={familyHistory.length > 3}
      >
        {(showingMore) => (
          <Box fontWeight={500}>
            <Typography variant="body2" color="textPrimary">{familyHistory.slice(0, showingMore ? undefined : 3).join(', ')}</Typography>
          </Box>
        )}
      </ShowMoreContent>
    );
  }, [ familyHistory ]);

  return (
    <PatientProfileInfoAccordion
      title="Family History"
      expandable={false}
      initialExpanded
    >
      {content}
    </PatientProfileInfoAccordion>
  );
};